import { cn } from '@cocoonspace/ui/lib/utils'
import { LoaderCircleIcon } from 'lucide-react'

export const PageLoader = ({
	className,
	size = 50,
}: {
	className?: string
	size?: number
}) => (
	<div className={cn('flex items-center justify-center', className)}>
		<LoaderCircleIcon
			className='text-primary animate-spin'
			size={size}
		/>
	</div>
)
